import React from 'react';
import './Galleries.css';
import { GALLERIES } from '../content';
import { ClipGrid, MediaBand, StillFigure } from '../components/Media';

export default function Galleries() {
  return (
    <section id="gallery" className="galleries">
      <MediaBand
        media={{
          kind: 'clip',
          id: 'sys-terminal',
          alt: 'A video rendered as colored character cells in a terminal window',
        }}
        className="galleries-band"
      >
        <p className="eyebrow eyebrow--accent">Gallery</p>
        <h2 className="section-title">Smaller pieces</h2>
        <p className="section-lede">
          Coursework and experiments. Any clip expands.
        </p>
        <p className="band-credit">
          Behind this: a real-time renderer drawing to a terminal, CPU-side, hand-optimized
          with SIMD intrinsics.
        </p>
      </MediaBand>

      <div className="galleries-body">
        {GALLERIES.map((g) => (
          <div className="gallery" key={g.id} id={g.id}>
            <div className="wrap gallery-head">
              <h3 className="gallery-title">{g.title}</h3>
              <p className="body-text gallery-blurb">{g.blurb}</p>
            </div>

            <div className="wrap wrap--wide gallery-media">
              {g.still && (
                <div className="gallery-still">
                  <StillFigure {...g.still} />
                </div>
              )}
              <ClipGrid
                clips={g.clips}
                square={g.square}
                cols={g.clips.length === 2 ? 2 : g.clips.length >= 4 ? 4 : 3}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
